enum ToastReducerActionTypeEnum {
  ADD_TOAST = 'addToast',
  CLOSE_TOAST = 'closeToast',
}

export { ToastReducerActionTypeEnum };
